export interface MergeResult {
    added: string[];
    duplicates: number;
    overflow: number;
}

export function mergeUnique(
    list: string[],
    urls: string[],
    max: number
): MergeResult {
    const seen = new Set(list);
    const fresh: string[] = [];
    for (const url of urls) {
        if (seen.has(url)) continue;
        seen.add(url);
        fresh.push(url);
    }
    const added = fresh.slice(0, Math.max(0, max - list.length));
    return {
        added,
        duplicates: urls.length - fresh.length,
        overflow: fresh.length - added.length,
    };
}
